/** Median of the values, 0 when there are none. */
export function median(values: number[]): number {
  const sorted = [...values].sort((a, b) => a - b)
  const mid = Math.floor(sorted.length / 2)
  const upper = sorted[mid] ?? 0
  const lower = sorted[mid - 1] ?? upper
  return sorted.length % 2 === 0 ? (lower + upper) / 2 : upper
}
